import httpClient from "./httpClient";

const prefix = "/reasons";

export async function readReason() {
  return (await httpClient.get(`${prefix}`)).data;
}
